import { createContext, useContext } from 'react';

import type { IRoleActions } from '../hooks/role-actions';

export const RoleActionContext = createContext<IRoleActions | null>(null);

export const useRoleActionContext = (): IRoleActions => {
	const roleActionContext = useContext(RoleActionContext);

	if (!roleActionContext) {
		throw new Error('useRoleActionContext must be used within a RoleActionContext.Provider');
	}

	// Returned by reference on purpose — spreading minted a new object on every call,
	// which defeats memoization in every consumer that puts this in a dependency array.
	return roleActionContext;
};
